import React, { Fragment, useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import NumberFormat from 'react-number-format';

import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';

import {
    KeyboardDatePicker
} from '@material-ui/pickers';

import {
    Select,
    InputLabel,
    MenuItem,
    FormControl,
    Box,
    Grid,
    colors,
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Button,
    TextField,
    Avatar,
    Paper,
    Tooltip,
    Chip,
    IconButton,
    FormLabel
} from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
    root: {

    },
    imgviewer1: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1),
        marginBottom: theme.spacing(1),
        color: colors.cyan[300],
        minHeight: 600,
        maxHeight: 600
    },
    avatar1: {
        color: colors.cyan[300],
        backgroundColor: colors.green[50],
        border: `1px dashed ${colors.green[200]}`,
        padding: 2,
        minWidth: 798,
        minHeight: 600,
        maxWidth: 798,
        maxHeight: 600
    },
    imgviewer2: {
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(1),
        color: colors.cyan[300],
        maxWidth: 230,
        maxHeight: 430
    },
    avatar2: {
        color: colors.cyan[300],
        backgroundColor: colors.green[50],
        border: `1px dashed ${colors.green[200]}`,
        width: 230,
        height: 430,
        maxWidth: 230,
        maxHeight: 430
    },
    doctitle1: {
        letterSpacing: '-0.05px',
        backgroundColor: colors.green[300],
        color: colors.common.white,
        marginBottom: -8,
        marginLeft: 10
    },
    doctitle2: {
        letterSpacing: '-0.05px',
        paddingRight: 15,
        paddingLeft: 5
    },
    doctitle3: {
        letterSpacing: '-0.05px',
        backgroundColor: colors.green[300],
        color: colors.common.white,
        marginLeft: 3
    },
    table: {
        maxHeight: 450
    }
}));

import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import ArrowBack from '@material-ui/icons/ArrowBack';
import ArrowForward from '@material-ui/icons/ArrowForward';
import PublishIcon from '@material-ui/icons/Publish';
import GetApp from '@material-ui/icons/GetApp';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import Check from '@material-ui/icons/Check';


const getName = (tipo) => {
    return tipo;
}

const fileSize = (bytes) => {
    var exp = Math.log(bytes) / Math.log(1024) | 0;
    var result = (bytes / Math.pow(1024, exp)).toFixed(2);
    return result + ' ' + (exp == 0 ? 'bytes' : 'KMGTPEZY'[exp - 1] + 'B');
}

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const Launch = ({ item, open, closeEdition, updateValues, openUploadReceipt, openReceiptEdition, selectedMode, receipt, changeReceipt, openDeletionReceipt, dependencies, openVerifyReceipt }) => {

    const classes = useStyles();

    var slideRef = {};

    const [docIndex, setDocIndex] = useState(0);
    const [specified, setSpecified] = useState(1);

    const next = (values) => {
        slideRef.current.goNext();
    }

    const previous = (values) => {
        slideRef.current.goBack();
    }

    const changeTypeLaunch = (event, values) => {
        for (let index = 0; index < dependencies.launchtypes.length; index++) {
            const element = dependencies.launchtypes[index];
            if (element.id == event.target.value) {
                setSpecified(Boolean(element.especificado));
            }
        }
    }

    const changeOperation = (event, values) => {
        values.typelaunch = null;
    }


    return (
        <Fragment>
            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="lg" className={classes.root} >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Lançamento
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                operation: Yup.string().required('Tipo de operação é obrigatória'),
                                typelaunch: Yup.string().required('Tipo de Lançamento é obrigatório'),
                                value: Yup.number().required('Valor é obrigatório')
                            })
                        }

                        onSubmit={(values, formik) => {
                            updateValues(values);
                            formik.setSubmitting(false);
                        }}

                    >

                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit} >

                                <Box my={2}>

                                    <Grid
                                        container
                                        spacing={2}
                                    >

                                        <Grid
                                            item
                                            md={4}
                                            xs={12}>

                                            <Grid
                                                container
                                                spacing={2}
                                            >

                                                <Grid item
                                                    md={6}
                                                    xs={12}>
                                                    <KeyboardDatePicker
                                                        readOnly={true}
                                                        margin="none"
                                                        cancelLabel="Cancelar"
                                                        id="date"
                                                        name="date"
                                                        label="Data Lançamento"
                                                        format="DD/MM/YYYY"
                                                        value={values.date}
                                                        inputVariant="outlined"
                                                        KeyboardButtonProps={{
                                                            'aria-label': 'change date',
                                                        }}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    md={6}
                                                    xs={12}>

                                                    <FormControl variant="outlined" fullWidth margin="nome">
                                                        <InputLabel shrink htmlFor="operation" required >Tipo de Operação</InputLabel>
                                                        <Select notched
                                                            autosize={true}
                                                            required
                                                            readOnly={(localStorage.getItem('profile') != 'ADM' && localStorage.getItem('profile') != 'ENG')}
                                                            error={Boolean(touched.operation && errors.operation)}
                                                            value={values.operation}
                                                            onChange={e => {
                                                                changeOperation(e, values);
                                                                handleChange(e);
                                                            }}
                                                            onBlur={handleBlur}
                                                            label="Tipo de Operação"
                                                            variant="outlined"
                                                            inputProps={{
                                                                name: 'operation',
                                                                id: 'operation',
                                                            }}
                                                        >
                                                            <MenuItem value={-1}><em>Débito</em></MenuItem>
                                                            <MenuItem value={1}><em>Crédito</em></MenuItem>

                                                        </Select>
                                                    </FormControl>

                                                </Grid>

                                                <Grid
                                                    item
                                                    md={12}
                                                    xs={12}>

                                                    <FormControl variant="outlined" fullWidth margin='none' >
                                                        <InputLabel shrink htmlFor="typelaunch" required>Tipo de Lançamento</InputLabel>
                                                        <Select notched
                                                            autosize={true}
                                                            required
                                                            error={Boolean(touched.typelaunch && errors.typelaunch)}
                                                            helperText={touched.typelaunch && errors.typelaunch}
                                                            value={values.typelaunch}
                                                            onChange={e => {
                                                                changeTypeLaunch(e, values);
                                                                handleChange(e);
                                                            }}
                                                            onBlur={handleBlur}
                                                            label="Tipo de Lançamento"
                                                            variant="outlined"
                                                            inputProps={{
                                                                name: 'typelaunch',
                                                                id: 'typelaunch',
                                                            }}
                                                        >
                                                            <MenuItem value={null}>
                                                                <em>Selecione um tipo de lançamento</em>
                                                            </MenuItem>

                                                            {dependencies.launchtypes.map((ltp) => (
                                                                (ltp.operacao == values.operation) ?
                                                                    <MenuItem key={ltp.id} value={ltp.id}>{ltp.nome}</MenuItem>
                                                                    : ""
                                                            ))}
                                                        </Select>
                                                    </FormControl>

                                                </Grid>

                                                <Grid
                                                    item
                                                    md={12}
                                                    xs={12}>
                                                    <TextField
                                                        error={Boolean(touched.description && errors.description)}
                                                        fullWidth
                                                        required={specified}
                                                        rows={3}
                                                        size={10}
                                                        multiline="true"
                                                        label="Descrição"
                                                        margin="none"
                                                        name="description"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        value={values.description}
                                                        variant="outlined"
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    md={6}
                                                    xs={12}>
                                                    <NumberFormat
                                                        fullWidth
                                                        error={Boolean(touched.value && errors.value)}
                                                        label="Valor"
                                                        margin="none"
                                                        name="value"
                                                        id="value"
                                                        required
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        value={values.value}
                                                        variant="outlined"
                                                        decimalScale="2"
                                                        fixedDecimalScale="true"
                                                        customInput={TextField}
                                                        InputLabelProps={{ shrink: true }}
                                                    />

                                                </Grid>

                                                <Grid
                                                    item
                                                    md={12}
                                                    xs={12}>
                                                    <TextField
                                                        error={Boolean(touched.lancer && errors.lancer)}
                                                        fullWidth
                                                        label="Lançado por"
                                                        margin="none"
                                                        name="lancer"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        value={values.launcher}
                                                        variant="outlined"
                                                        InputLabelProps={{ shrink: true }}
                                                        InputProps={{ readOnly: true }}
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    md={12}
                                                    xs={12}>
                                                    <TextField
                                                        error={Boolean(touched.aprover && errors.aprover)}
                                                        fullWidth
                                                        label="Verificado por"
                                                        margin="none"
                                                        name="aprover"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        value={(values.aprover) ? (values.aprover + ' em ' + moment(values.aproved).format('DD/MM/yyyy')) : ""}
                                                        variant="outlined"
                                                        InputLabelProps={{ shrink: true }}
                                                        InputProps={{ readOnly: true }}
                                                    />
                                                </Grid>

                                            </Grid>

                                        </Grid>

                                        <Grid
                                            item
                                            md={8}
                                            xs={12}>

                                            <Grid
                                                container
                                                xs="auto"
                                            >

                                                <Grid
                                                    item
                                                    md={12}
                                                    xs={12}
                                                >

                                                    <FormControl required fullWidth >

                                                        <Grid
                                                            container
                                                            justifyContent="center"
                                                            alignItems="baseline"
                                                            spacing={1}
                                                        >

                                                            <Grid
                                                                item
                                                                md={12}
                                                                xs={12}>
                                                                {(receipt) ? (receipt.descricao == 'Novo Documento') ?
                                                                    (
                                                                        <Tooltip title={`Enviado: ` + moment(receipt.dataEnvio).format('DD/MM/yyyy HH:mm')}>
                                                                            <Chip className={classes.doctitle1} label={receipt.descricao} variant="outlined" size='small' >
                                                                            </Chip>
                                                                        </Tooltip>
                                                                    ) : (
                                                                        <Tooltip title={`Enviado :` + moment(receipt.dataEnvio).format('DD/MM/yyyy HH:mm')}>
                                                                            <Typography variant='h4' color='secondary' className={classes.doctitle2} noWrap >{(receipt.descricao) ? receipt.descricao : "Novo Documento"}
                                                                            </Typography>
                                                                        </Tooltip>
                                                                    ) :
                                                                    (<Tooltip title={`Enviar Agora :` + moment().format('DD/MM/yyyy HH:mm')}>
                                                                        <Chip className={classes.doctitle1} label="Nenhum Comprovante" variant="outlined" size='small' >
                                                                        </Chip>
                                                                    </Tooltip>)}
                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={12}
                                                                xs={12}
                                                            >
                                                                <Tooltip title={(receipt) ? receipt.nome + ` - ` + fileSize(receipt.tamanho) : ""}>
                                                                    <Box className={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? classes.imgviewer2 : classes.imgviewer1} >
                                                                        <Slide ref={slideRef} {...{
                                                                            duration: 6000,
                                                                            transitionDuration: 1000,
                                                                            infinite: false,
                                                                            indicators: false,
                                                                            arrows: false,
                                                                            autoplay: false,
                                                                            pauseOnHover: false,
                                                                            onChange: (oldIndex, newIndex) => {
                                                                                setDocIndex(newIndex);
                                                                                changeReceipt(dependencies.receipts[newIndex])
                                                                            },
                                                                            prevArrow: <div style={{ width: "30px", marginRight: "-30px" }}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#fff"><path d="M242 180.6v-138L0 256l242 213.4V331.2h270V180.6z" /></svg></div>,
                                                                            nextArrow: <div style={{ width: "30px", marginLeft: "-30px" }}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#fff"><path d="M512 256L270 42.6v138.2H0v150.6h270v138z" /></svg></div>
                                                                        }
                                                                        } autoplay={false} disabled={!values.value || !values.description}>
                                                                            {(dependencies.receipts.length == 0) ?
                                                                                <Box
                                                                                    component={IconButton}
                                                                                    style={{ margin: 0, padding: 0 }}
                                                                                    onClick={() => { openUploadReceipt(values) }}
                                                                                >
                                                                                    <Avatar variant='rounded'
                                                                                        className={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? classes.avatar2 : classes.avatar1}
                                                                                        style={{ objectFit: 'contain', height: 200 }}>
                                                                                        Sem Imagem
                                                                                    </Avatar>
                                                                                </Box>
                                                                                :
                                                                                dependencies.receipts.map((doc, index) =>
                                                                                    <object data={process.env.REACT_APP_REMOTE_REPO + '/receipts/' + doc.lancamento + '/' + doc.nome}
                                                                                        type={doc.formato}
                                                                                        className={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? classes.avatar2 : classes.avatar1}
                                                                                        style={{ objectFit: 'contain', height: '100%' }}
                                                                                    />
                                                                                )
                                                                            }
                                                                        </Slide>

                                                                    </Box>
                                                                </Tooltip>

                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={1}
                                                                xs={4}
                                                            >
                                                                <Button
                                                                    color="secondary"
                                                                    size="medium"
                                                                    disabled={dependencies.receipts.length == 0}
                                                                    children={<ArrowBack />}
                                                                    onClick={() => { previous(values) }}
                                                                    variant="outlined"></Button>
                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={1}
                                                                xs={4}
                                                            >
                                                                <Button
                                                                    color="secondary"
                                                                    size="medium"
                                                                    disabled={dependencies.receipts.length == 0}
                                                                    children={<ArrowForward />}
                                                                    onClick={(event) => { next(values) }}
                                                                    variant="outlined"></Button>
                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={1}
                                                                xs={4}
                                                            >
                                                                <Button
                                                                    color="secondary"
                                                                    disabled={((localStorage.getItem('profile') != 'ADM' || localStorage.getItem('profile') != 'ENG') && values.operation == 1)}
                                                                    size="medium"
                                                                    children={<PublishIcon />}
                                                                    onClick={() => { openUploadReceipt(values) }}
                                                                    variant="outlined"></Button>
                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={1}
                                                                xs={4}
                                                            >
                                                                <Button
                                                                    disabled={dependencies.receipts.length == 0 || !receipt}
                                                                    variant="outlined"
                                                                    color="secondary"
                                                                    target="_blank"
                                                                    children={<GetApp />}
                                                                    size="medium"
                                                                    href={(receipt) ? process.env.REACT_APP_REMOTE_REPO + '/receipts/' + receipt.lancamento + '/' + receipt.nome : "#"}>
                                                                </Button>
                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={1}
                                                                xs={4}
                                                            >
                                                                <Button
                                                                    disabled={dependencies.receipts.length == 0 || !receipt || ((localStorage.getItem('profile') != 'ADM' && localStorage.getItem('profile') != 'ENG') && values.operation == 1)}
                                                                    color="secondary"
                                                                    size="medium"
                                                                    children={<EditRoundedIcon />}
                                                                    onClick={() => { openReceiptEdition(receipt) }}
                                                                    variant="outlined"></Button>
                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={1}
                                                                xs={4}
                                                            >
                                                                <Button
                                                                    disabled={dependencies.receipts.length == 0 || !receipt || ((localStorage.getItem('profile') != 'ADM' && localStorage.getItem('profile') != 'ENG') && values.operation == 1)}
                                                                    color="secondary"
                                                                    size="medium"
                                                                    children={<DeleteRoundedIcon />}
                                                                    onClick={() => { openDeletionReceipt(receipt) }}
                                                                    variant="outlined"></Button>
                                                            </Grid>

                                                            {((localStorage.getItem('profile') == 'ADM' || localStorage.getItem('profile') == 'ENG')) ?
                                                                (<Grid
                                                                    item
                                                                    md={1}
                                                                    xs={4}
                                                                >
                                                                    <Button
                                                                        disabled={dependencies.receipts.length == 0 || !receipt || receipt.verificado}
                                                                        color='primary'
                                                                        size="medium"
                                                                        children={<Check />}
                                                                        onClick={() => { openVerifyReceipt(receipt) }}
                                                                        variant="contained"></Button>
                                                                </Grid>) : ("")}



                                                            <Grid
                                                                item
                                                                md={1}
                                                                xs={3}>
                                                                <Chip variant='outlined' size='small' className={classes.doctitle3} label={(receipt) ? ("( " + (docIndex + 1) + "/" + dependencies.receipts.length + " )") : "0/0"} />
                                                            </Grid>
                                                            <Grid
                                                                item
                                                                md={4}
                                                                xs={9}>
                                                                <Typography variant='h5' color='secondary' >{(receipt) ? ((receipt.tipo) ? getName(receipt.tipo) : "Tipo Não Informado") : "0/0"}</Typography>
                                                            </Grid>

                                                        </Grid>
                                                    </FormControl>
                                                </Grid>
                                            </Grid>

                                        </Grid>



                                    </Grid>
                                </Box>

                                <Divider />

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting || ((localStorage.getItem('profile') != 'ADM' && localStorage.getItem('profile') != 'ENG') && values.operation == 1)}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Salvar
                                            </Button>
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => {
                                                    setDocIndex(0);
                                                    closeEdition();
                                                }}>
                                                Cancelar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment >
    );
};

export default Launch;
